import { getController } from '@/services/service'

export const commentService = {
	...getController('comments'),
}

export default commentService
